import { render, staticRenderFns } from "./Mazes.vue?vue&type=template&id=6234c5eb&"
import script from "./Mazes.vue?vue&type=script&lang=js&"
export * from "./Mazes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports